<template>
<qrcode-vue
    :value="config.url"
    :level="config.level"
    render-as="svg"
    :background="config.backgroundColor"
    :foreground="config.color"
    :gradient="config.showGradiant"
    :gradient-type="config.gradiantType"
    :gradient-start-color="config.startColor"
    :gradient-end-color="config.endColor"
    :size="qrSize"
  />

</template>

<script lang="ts">

export default {
  name: "QrCodeWidget",
};

</script>

<script setup lang="ts">
import { computed, defineProps } from 'vue';
import QrcodeVue from 'qrcode.vue';
const props = defineProps<{
  config: any;
}>();

const qrSize = computed(() =>
  Math.max(props.config.width, props.config.height)
);
</script>